import { call, put, takeLatest } from 'redux-saga/effects';
import { supervisionService } from './supervision.service';
import { GET_SUPERVISION_SUMMARY, GET_SUPERVISION_SUMMARY_SUCCESS } from './supervision.types';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';

function* getSupervisionSummary(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(supervisionService.getSupervisionSummaryService, action.payload);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_SUPERVISION_SUMMARY_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

export const watchSupervision = function* watchSupervisionSaga() {
    yield takeLatest(GET_SUPERVISION_SUMMARY, getSupervisionSummary);
};
